import React from 'react';
import ResetLogin from '../../components/extern/LoginRegisterReset/ResetPassword';

const ResetLoginPage = () => {
  return (
    <main>
      <ResetLogin />
    </main>
  );

};

export default ResetLoginPage;
